// extracted by mini-css-extract-plugin
module.exports = {"vGray14":"#7d85a4","more":"CalendarMonthMore_more__2U6li"};